import { render, staticRenderFns } from "./UiCheckboxRevenue.vue?vue&type=template&id=bf17faae&scoped=true"
import script from "./UiCheckboxRevenue.vue?vue&type=script&lang=js"
export * from "./UiCheckboxRevenue.vue?vue&type=script&lang=js"
import style0 from "./UiCheckboxRevenue.vue?vue&type=style&index=0&id=bf17faae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf17faae",
  null
  
)

export default component.exports